export const LIMIT = 15;
export const ADMIN_COOKIE_NAME = "admin-token";
export const ADMIN_COOKIE_ROLE = "admin-role";
